// src/components/layout/Layout.tsx
import React, { useEffect, useState } from 'react';
import TopBar from './TopBar';
import Sidebar from './SideBar'; // we'll create this next
import { Box } from '@mui/material';
import { FormattingProvider } from '../../context/FormattingContext';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleMobileMenuToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  const handleMobileClose = () => {
    setMobileOpen(false);
  };

  useEffect(() => {
    if (!isMobile) {
      setMobileOpen(false);
    }
  }, [isMobile]);

  return (
    <FormattingProvider>
      <Box sx={{ display: 'flex', minHeight: '100dvh', width: '100%' }}>
        <Sidebar mobileOpen={mobileOpen} onMobileClose={handleMobileClose} />
        <Box sx={{ flexGrow: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
          <TopBar onMobileMenuToggle={isMobile ? handleMobileMenuToggle : undefined} />
          <Box sx={{ p: { xs: 2, md: 3 }, minWidth: 0, flexGrow: 1 }}>{children}</Box>
        </Box>
      </Box>
    </FormattingProvider>
  );
};

export default Layout;
